export default "__VITE_ASSET__a0c91874__"